import type { FrameStateStatistic } from '@/type';

/**
 * FrameStateStatistic에서 전체 프레임 수를 계산합니다.
 */
export const calculateTotalFrame = (
  frameProgress: Nullish<FrameStateStatistic>,
): number => {
  const progress = frameProgress ?? {
    prework: 0,
    working: 0,
    reject: 0,
    review: 0,
    reviewing: 0,
    done: 0,
  };

  return (
    progress.prework +
    progress.working +
    progress.reject +
    progress.review +
    progress.reviewing +
    progress.done
  );
};
